import { io, type Socket } from 'socket.io-client';
import { getAuthToken } from './api';

let _socket: Socket | null = null;

export function getSocket(): Socket {
  if (!_socket) {
    _socket = io('/', {
      path: '/ws/',
      autoConnect: false,
      reconnection: true,
      reconnectionDelay: 2000,
    });
  }
  return _socket;
}

export function connectSocket() {
  const s = getSocket();
  // Refresh auth token on every connect attempt.
  s.auth = { token: getAuthToken() };
  if (!s.connected) s.connect();
}

export function disconnectSocket() {
  _socket?.disconnect();
}

export function subscribeSession(sessionId: string) {
  getSocket().emit('subscribe', sessionId);
}

export function unsubscribeSession(sessionId: string) {
  getSocket().emit('unsubscribe', sessionId);
}
